import { API_URL } from "../environment";

const ApiKey = {
  api: API_URL,
};


export default ApiKey;
